<template>
  <div>
    <!-- Trackable Ad Image -->
    <v-img
      src="https://firebasestorage.googleapis.com/v0/b/safaschools-a6f8c.appspot.com/o/300x100.png?alt=media&token=29b7d45b-d356-4bf1-8242-fd8f49edf772"
      @click="handleClick"
      style="cursor: pointer"
    ></v-img>


  </div>
</template>

<script>
import { onMounted } from 'vue';
import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  increment
} from "firebase/firestore";
import { firebaseApp } from "../firebaseConfig";

const db = getFirestore(firebaseApp);

export default {
  name: 'TrackableImage',
  data() {
    return {
      ad1Views: 0,
      ad1Clicks: 0
    };
  },
  async mounted() {
    // Increment view count on mount, then fetch latest stats
    await this.incrementAd1View();
    await this.fetchAd1Stats();
  },
  methods: {
    // Fetch the current ad1Views and ad1Clicks from Firestore
    async fetchAd1Stats() {
      const statsRef = doc(db, 'durbanjuly_farpost_stats', 'counts');
      const statsSnap = await getDoc(statsRef);
      if (statsSnap.exists()) {
        const data = statsSnap.data();
        this.ad1Views = data.ad1Views || 0;
        this.ad1Clicks = data.ad1Clicks || 0;
      } else {
        // If doc doesn't exist yet, initialize local state
        this.ad1Views = 0;
        this.ad1Clicks = 0;
      }
    },

    // Increment the Ad 1 view count
    async incrementAd1View() {
      const statsRef = doc(db, 'durbanjuly_farpost_stats', 'counts');
      const statsSnap = await getDoc(statsRef);
      if (statsSnap.exists()) {
        await updateDoc(statsRef, {
          ad1Views: increment(1)
        });
      } else {
        await setDoc(statsRef, {
          ad1Views: 1,
          ad1Clicks: 0
        });
      }
    },

    // Increment the Ad 1 click count
    async incrementAd1Click() {
      const statsRef = doc(db, 'durbanjuly_farpost_stats', 'counts');
      const statsSnap = await getDoc(statsRef);
      if (statsSnap.exists()) {
        await updateDoc(statsRef, {
          ad1Clicks: increment(1)
        });
      } else {
        await setDoc(statsRef, {
          ad1Views: 0,
          ad1Clicks: 1
        });
      }
    },

    // Handle click: update Firestore, refresh stats, then open link in new tab
    async handleClick() {
      await this.incrementAd1Click();
      await this.fetchAd1Stats();
      window.open(
        'http://static.clvads.com/durbanjuly_farpost/index.html',
        '_blank',
        'noopener,noreferrer'
      );
    }
  }
};
</script>

<style scoped>
.v-image--image {
  transition: opacity 0.3s ease;
}
.v-image--image:hover {
  opacity: 0.8;
}
.ad-stats p {
  margin: 0.25rem 0;
  font-size: 0.9rem;
}
</style>
